<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="loom">
      <path
        id="Vector"
        d="M45 21.802H32.2055L43.2856 15.404L41.0883 11.596L30.0068 17.994L36.4027 6.913L32.5959 4.715L26.1987 15.7932V3H21.8013V15.7946L15.4041 4.715L11.5959 6.913L17.9918 17.9912L6.9131 11.596L4.71443 15.404L15.7945 21.802H3V26.1994H15.7931L4.71443 32.5974L6.9117 36.4054L17.9932 30.0074L11.5959 41.0884L15.4027 43.2864L21.8013 32.2068V45H26.1987V31.9324L32.7135 43.2164L36.2837 41.1556L29.7675 29.8688L41.0855 36.404L43.2842 32.596L32.2055 26.198H44.9986V21.802H45ZM24 29.978C23.215 29.9781 22.4377 29.8235 21.7125 29.5231C20.9872 29.2227 20.3282 28.7823 19.7731 28.2272C19.218 27.672 18.7776 27.0129 18.4772 26.2875C18.1767 25.562 18.022 24.7845 18.0219 23.9993C18.0218 23.2141 18.1763 22.4365 18.4766 21.711C18.7769 20.9855 19.2172 20.3263 19.7721 19.771C20.3271 19.2157 20.986 18.7752 21.7112 18.4746C22.4364 18.174 23.2136 18.0193 23.9986 18.0192C25.5839 18.019 27.1044 18.6488 28.2255 19.77C29.3466 20.8913 29.9765 22.4121 29.9767 23.9979C29.9769 25.5837 29.3473 27.1047 28.2265 28.2262C27.1056 29.3477 25.5853 29.9778 24 29.978Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
